"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            background: 'white',
            marginTop: 4,
            borderRadius: 4,
            boxShadow: theme_1.default.shadows.strong,
            overflow: 'hidden',
            padding: '8px 0px',
        },
        headerText: {
            padding: '8px 24px',
            background: 'white',
        },
        fetchMore: {
            display: 'grid',
            gap: 12,
            height: 32,
            justifyContent: 'center',
            alignItems: 'center',
            gridAutoFlow: 'column',
        },
        groupLabel: {
            padding: '12px 24px',
            backgroundColor: 'white',
        },
    });
});
